import {shallowEqual, useSelector} from 'react-redux'
import {IProfile} from '../models'
import {RootState} from '../store/RootReducer'

export const useUserLoggedIn = () => {
  const user = useSelector<RootState>(({auth}) => auth?.user, shallowEqual) as IProfile
  return user
}
